import { Component, OnInit,Inject } from '@angular/core';
import { ToastrManager } from 'ng6-toastr-notifications';
import { DatabaseService } from 'src/_services/DatabaseService';
import { DialogComponent } from 'src/app/dialog.component';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute,Router } from '@angular/router';



@Component({
  selector: 'app-travel-status-modal',
  templateUrl: './userview-target-modal.component.html'
})
export class UserviewTargetModalComponent implements OnInit {
    salesUser:any=[]
    monthList:any=['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    segmentList:any=[]
    savingFlag:any=false;
    today_date: any = new Date();
    currentYear:any=this.today_date.getFullYear()
    yearList:any=[]
    allSegmentId:any=[];
  
  constructor(@Inject(MAT_DIALOG_DATA)public data,
  public alrt: MatDialog,
  public serve:DatabaseService,
  public alert:DialogComponent,
  public navparams: ActivatedRoute,
  public toast:ToastrManager) {
    this.getSalesUser('');
    for(let i = this.currentYear; i<=this.currentYear+1; i++){
        this.yearList.push(i)
      }
    
  }
  
  ngOnInit() {
  }
  
  addTarget(){
    let apiname;
    if(this.data.from=='addTarget'){
      apiname="Target/addSecondaryTarget"
    }
     if(this.data.from=='addPrimaryTarget'){
      apiname="Target/addPrimaryTarget"
    }
    this.serve.post_rqst({'data':this.data}, apiname).subscribe(result => {
        if (result['statusCode'] == 200) {
            this.toast.successToastr(result['statusMsg']);
            this.alrt.closeAll();
        }else{
            this.toast.errorToastr(result['statusMsg']);
        }
    
    }, ()=>{
        this.toast.errorToastr('Something went wrong');
    })
  }
  getSegment() {
    this.serve.post_rqst({'id':this.data.user_id}, "Target/usersSegment").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.segmentList = result['result'];
      }else{
        this.segmentList = []
      }
    }))
  }
  getSalesUser(searcValue) {
    this.serve.post_rqst({ 'search': searcValue }, "Target/salesUser").subscribe((response => {
      if (response['statusCode'] == 200) {
        this.salesUser = response['result'];
      } else {
        this.toast.errorToastr(response['statusMsg']);
      }

    }));
  }

  selectAll1(action){
    if(action=='selectAll'){
      if(this.data.selectID==true){
        for(let x=0; x<this.segmentList.length; x++){this.allSegmentId.push(this.segmentList[x].segment_id+'');}
        console.log(this.allSegmentId)
        this.data.segment_id=this.allSegmentId
        console.log(this.data.segment_id)

      }else{this.data.segment_id=[]; this.allSegmentId=[]}
    }else if(action=='selectionChange'){
      if(this.segmentList.length==this.data.segment_id.length){this.data.selectID=true;}
      else{this.data.selectID=false;}
    }
  }

}